<template>
    <div>

        <el-card v-loading='loading'>

            <!-- 请选择商品状态 -->
            <!-- multiple 是否多选 -->
            <el-select size="mini" style="margin-bottom: 10px" v-model="selectProductStatus" placeholder="请选择商品状态">
                <el-option
                    v-for="item in ProductStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>

            <!-- 表格 -->
            <el-table
            stripe
            height="690"
            :cell-style="{padding:1,borderColor:'#000000'}"
            :header-cell-style="{borderColor:'#000000',color:'#0099ff'}"
            :data="tableData"
            border
            fit
            highlight-current-row
            style="border: 1px solid #000000;width:100%"
            :default-sort = "{prop: 'date_paid_gmt', order: 'descending'}">

                <!-- 商品id -->
                <el-table-column
                    prop="product_id"
                    label="商品id"
                    align="center"
                    ></el-table-column>

                <!-- 商品状态 -->
                <el-table-column
                    prop="product_status"
                    label="商品状态"
                    align="center"
                    ></el-table-column>

                <!-- 操作时间 -->
                <el-table-column
                    prop="time"
                    label="操作时间"
                    align="center"
                    ></el-table-column>

                <!-- 操作人 -->
                <el-table-column
                    prop="person"
                    label="操作人"
                    align="center"
                    ></el-table-column>

            </el-table>

            <!-- 分页 -->
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="pss"
            :page-size="ps"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            style="display:flex; justify-content: center">
            </el-pagination>

        </el-card>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true, // 加载动画
                currentPage: 1, // 页面打开默认展示哪一页
                pss: [100, 200, 500, 1000], // 设置页面当中 可以选择的 每页信息条数
                ps: 100, // 设置每页默认展示信息条数
                total: 1000, // 页面信息总条数
                ProductStatus:[{ text: '待审核', value: '待审核' }, { text: '待发货-制作中', value: '待发货-制作中' }, { text: '待发货', value: '待发货' }, { text: '仓库已发货', value: '仓库已发货' }, { text: '已到货代', value: '已到货代' }, { text: '物流已发货', value: '物流已发货' }, { text: '异常', value: '异常' }, { text: '暂停', value: '暂停' }, { text: '已取消', value: '已取消' }, { text: '已退款', value: '已退款' }, { text: '缺货', value: '缺货' }], //商品状态
                selectProductStatus:[],//筛选商品状态
            }
        },
        created () {
            this.tableData = [
                {
                    product_id: 111,
                    product_status: '待审核',
                    time: '2023-01-29 11:11:11',
                    person: '张三'
                },
                {
                    product_id: 111,
                    product_status: '待审核',
                    time: '2023-01-29 11:11:11',
                    person: '张三'
                },
                {
                    product_id: 111,
                    product_status: '待审核',
                    time: '2023-01-29 11:11:11',
                    person: '张三'
                },
                {
                    product_id: 111,
                    product_status: '待审核',
                    time: '2023-01-29 11:11:11',
                    person: '张三'
                },
                {
                    product_id: 111,
                    product_status: '待审核',
                    time: '2023-01-29 11:11:11',
                    person: '张三'
                }
            ]
            this.loading = false;
        },
        methods: {

            // 设置每页条数
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            // 点击前往哪一页
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>